import React from "react";
import Img from "gatsby-image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import theme from "../styles/theme";

const SlickSlider = ({ data }) => {
  return (
    <section
      css={`
        position: relative;

        overflow: hidden;
        margin-bottom: 100px;
        > div {
          width: 100%;
        }
        ${theme.max900} {
          margin-bottom: 0;
        }
      `}
    >
      <Slider {...settings}>
        {data.map(item => {
          return (
            <div>
              <Img className="img" fluid={item.fluid} alt={item.alt} />
            </div>
          );
        })}
      </Slider>
    </section>
  );
};

export default SlickSlider;

const settings = {
  fade: true,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
